import { GradedText } from './GradedText';
export function isGradedText(node) {
    return node !== null && typeof node === 'object' && node instanceof GradedText;
}
export default isGradedText;    //# sourceMappingURL=isGradedText.js.map
